import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"


export default function useFaqs(props, emit, faqData) {

    // Get toast interface
    const toast = useToast()

    const faqStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getFaqs = (url = null) => {
        store.dispatch("getFaqs", {
            url,
            search: search.value,
            status: faqStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true

        if (faqData.value.id) {
            store.dispatch('updateFaq', faqData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("پرسش و پاسخ موردنظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getFaqs")
                        closeModal()
                    }
                })
        }
    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }

    return {
        show,
        faqStatus,
        search,
        perPage,
        loading,
        errors,
        getFaqs,
        onSubmit,
        closeModal,
    }
}